module.exports = "/_next/static/images/3e07c11cea9c9ca77df5c3bde32d1fab-savings-hero-lg.jpg.webp";